import { Mail, MapPin, Phone } from "lucide-react";
import logo from "@images/logo.svg";

const serviceLinks = ["О сервисе", "Подписка", "Премьеры", "Сертификаты", "Партнёрам", "Новости", "Контакты"];
const catalogLinks = ["Фантастика", "Боевики", "Драмы", "Фэнтези", "Ужасы", "Триллеры", "Комедии", "Аниме", "Документальные", "Детективы", "Биографии", "Мелодрамы", "Криминал", "Приключения"];

function Contact({ icon: Icon, label, children }) {
  return (
    <div className="catalog-footer-contact">
      <div><Icon size={21} strokeWidth={1.5} /><span>{label}</span></div>
      <p>{children}</p>
    </div>
  );
}

export default function CatalogFooter() {
  return (
    <footer className="catalog-footer">
      <div className="catalog-footer-inner">
        <img className="catalog-footer-logo" src={logo} alt="SMOTRI" />
        <div className="catalog-footer-rule" />

        <div className="catalog-footer-columns">
          <div className="catalog-footer-links">{serviceLinks.map((link) => <a href="#footer" key={link}>{link}</a>)}</div>

          <div className="catalog-footer-catalog">
            <h2>Каталог</h2>
            <div>
              <div>{catalogLinks.slice(0, 7).map((link) => <a href="#footer" key={link}>{link}</a>)}</div>
              <div>{catalogLinks.slice(7).map((link) => <a href="#footer" key={link}>{link}</a>)}</div>
            </div>
          </div>

          <div className="catalog-footer-contact-column">
            <h2>Помощь</h2>
            <Contact icon={Phone} label="Поддержка:">8 800 555 35 35</Contact>
            <Contact icon={MapPin} label="Компания:">SMOTRI Streaming Service</Contact>
            <Contact icon={Mail} label="Почта:">support@smotri.tv</Contact>
          </div>

          <div className="catalog-footer-contact-column">
            <h2>Компания</h2>
            <Contact icon={Phone} label="Для партнёров:">+7 (495) 120 20 20</Contact>
            <Contact icon={MapPin} label="Юр. информация:">Пользовательское соглашение и политика конфиденциальности</Contact>
            <label className="catalog-footer-search"><span>Поиск...</span><input aria-label="Поиск в футере" /></label>
          </div>
        </div>

        <div className="catalog-footer-rule" />
        <div className="catalog-footer-bottom">© 2026 SMOTRI Co. Ltd.</div>
      </div>
    </footer>
  );
}
